import React, { useEffect, useState } from "react";
import { MessageCircle, ArrowUp } from "lucide-react";
import { COMPANY } from "../mock";
import { useI18n } from "../i18n";

export default function FloatingActions() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onS = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onS);
    return () => window.removeEventListener("scroll", onS);
  }, []);
  return (
    <>
      <a href={`https://wa.me/${COMPANY.phones[0].wa}`} target="_blank" rel="noopener noreferrer" className="wafab" aria-label="WhatsApp">
        <MessageCircle size={20} />
        <span>{t({ es: "Cotizar por WhatsApp", en: "Quote via WhatsApp" })}</span>
      </a>
      <button className={`totop ${show ? "show" : ""}`} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Top">
        <ArrowUp size={18} />
      </button>
    </>
  );
}
